import type { NavigateFunction, To } from "react-router-dom";

type NavigateOptions = {
  replace?: boolean;
  state?: unknown;
};

let navigateFn: NavigateFunction | null = null;

export function registerAppNavigate(navigate: NavigateFunction) {
  navigateFn = navigate;
}

export function unregisterAppNavigate() {
  navigateFn = null;
}

/** Client-side navigation when the router is mounted; falls back to full reload. */
export function navigateInApp(to: To, options?: NavigateOptions): boolean {
  if (typeof window !== "undefined") {
    sessionStorage.setItem("epInAppNavigationAt", String(Date.now()));
  }

  if (navigateFn) {
    navigateFn(to, options);
    return true;
  }

  const path = typeof to === "string" ? to : `${to.pathname ?? ""}${to.search ?? ""}`;
  window.location.assign(path || "/");
  return false;
}
